import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "./AuthContext.js";

/**
 * Guards the accounts screen specifically — a narrower sibling of
 * `RequireAuth`, not a replacement for it. Only ever used nested inside a
 * route that `RequireAuth` already wraps (`AppRoutes.tsx`'s `/accounts`
 * route), so `useAuth().account` is guaranteed non-null here on a hosted
 * deployment; on desktop it is always `null` (no accounts concept at all —
 * see `AuthContext.tsx`), so this redirects there unconditionally, which is
 * correct: there is no accounts screen on a single till.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { account } = useAuth();

  if (account?.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
